import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ReactDOM from 'react-dom';
import App from './App';
import reducer from './reducers';
import middleware from './middleware';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import { formatDate } from './utils';
import { createTheme } from '@mui/material/styles';
var theme = createTheme({
  palette: {
    primary: {
      main: '#000'
    },
    secondary: {
      main: '#f44336'
    }
  }
});
var today = new Date();
var firstEventDate = new Date(eventIntros[0]);
var lastEventDate = new Date(eventIntros[eventIntros.length - 1]);
// If todays date is less than the first day of the event week, use the first day. Otherwise, use today's date.
var startDate = today < firstEventDate || today > lastEventDate ? formatDate(firstEventDate) : formatDate(today);
var initialState = {
  events: null,
  loadingEvents: true,
  selectedCat: eventCats.length ? eventCats[0].slug : null,
  selectedDay: startDate,
  selectedEvent: null,
  selectedEventType: nycjwEventSettings.selected_event_type,
  selectedTestDay: null,
  today: new Date(),
  mapToggled: false,
  mapDate: false
};
var store = createStore(reducer, initialState, middleware);
ReactDOM.render( /*#__PURE__*/React.createElement(Provider, {
  store: store
}, /*#__PURE__*/React.createElement(BrowserRouter, {
  basename: "".concat(process.env.NODE_ENV === 'production' ? 'events' : 'nycjw/events')
}, /*#__PURE__*/React.createElement(Routes, null, /*#__PURE__*/React.createElement(Route, {
  path: "*",
  element: /*#__PURE__*/React.createElement(App, null)
}), /*#__PURE__*/React.createElement(Route, {
  path: "/",
  exact: true,
  element: /*#__PURE__*/React.createElement(App, null)
}), /*#__PURE__*/React.createElement(Route, {
  path: "/:event",
  exact: true,
  element: /*#__PURE__*/React.createElement(App, null)
}), /*#__PURE__*/React.createElement(Route, {
  path: "/:event/:supporting",
  exact: true,
  element: /*#__PURE__*/React.createElement(App, null)
})))), document.getElementById("root"));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();